(function() {
    "use strict";

    // Only run on collection page
    if (document.getElementsByClassName("template-collection").length === 0) {
        return;
    }

    // Init
    const filterList = document.getElementById("filter-list");
    const collectionBody = document.querySelector('.collection--product__wrap');
    const inputs = document.querySelectorAll("#sort-by input");
    const spinner = document.querySelector('.index-spinner__wrap');
    let scrollTop;
    let params = (new URL(document.location)).searchParams;
    let productID = params.get('id');
    var scrollObject = new SmoothScroll();
    var product = document.getElementById(productID);
    let productScrolledTo = false;


    filterList.addEventListener("click", setCollectionBodyHeight);
    window.addEventListener("resize", debounce(setCollectionBodyHeight));


    setCollectionBodyHeight();
    initSorting();

    if(productID) {
        if(!product){
            startScroll();
        } else {
            productScrolledTo = true;
            spinner.style.display = "none";
        }

    } else if(spinner){
        spinner.style.display = "none";
    }

    function startScroll() {
        var button = document.querySelector('.collection--button');
        scrollObject.animateScroll(button);
    }

        new Ajaxinate({
        method: "scroll",
        container: "#collectionContainer",
        pagination: "#collectionPagination",
        callback: findProductInView
    });

    //////////

    function initSorting() {
        Shopify.queryParams = {};
        if (location.search.length) {
            const aCouples = location.search.substr(1).split("&");
            let aKeyValue;
            for (let i = 0; i < aCouples.length; i++) {
                aKeyValue = aCouples[i].split("=");
                if (aKeyValue.length > 1) {
                    Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(
                        aKeyValue[1]
                    );
                }
            }
        }

        Array.prototype.forEach.call(inputs, function(input) {
            if (Shopify.queryParams.sort_by === input.value) {
                input.checked = true;
            }
            input.addEventListener("change", function(evt) {
                if (evt.target.checked) {
                    Shopify.queryParams.sort_by = evt.target.value;
                    location.search = jQuery.param(Shopify.queryParams).replace(/\+/g, "%20");
                }
            });
        });
    }



    function setCollectionBodyHeight() {
        // Clicking the label fires its own click event. Ignore it.
        if (event && event.target.tagName === "LABEL") {
            return;
        }

        // Toggling the nav extends/retracts the body which can cause
        // unwanted scroll position jumps.
        disableScroll();

        // Reset the body height in all cases.
        collectionBody.style.height = "";

        // Ignore on mobile.
        if (window.innerWidth < 720) {
            enableScroll();
            return;
        }

        // Set the colleciton body height if necessary.
        const collectionBodyHeight = collectionBody.offsetHeight;
        const filterHeight = filterList.offsetHeight;

        if (collectionBodyHeight < filterHeight) {
            collectionBody.style.height = filterHeight + "px";
        }

        // Re-enable scrolling after layout/height changes are applied.
        window.requestAnimationFrame(enableScroll);
    }

    function disableScroll() {
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        window.addEventListener("scroll", scrollPause);
    }

    function enableScroll() {
        window.removeEventListener("scroll", scrollPause);
    }

    function scrollPause() {
        window.scrollTo(0, scrollTop);
    }

    function findProductInView () {
        if(productID){
            product = document.getElementById(productID);
            if(!product) {
                startScroll();
            } else if(!productScrolledTo){
                product.scrollIntoView();
                spinner.style.display = "none";
                productScrolledTo = true;
            }
        }
    }
})();
